import { Link, useInRouterContext, useLocation } from "react-router-dom";

import { useDirectorContext } from "@contexts/director";
import {
  COMPLEMENTARY_LABEL,
  COMPLEMENTARY_PATH,
  PRIMARY_SCREENS,
  complementaryPageFor,
} from "../../../outlets/director/complementaryPages";

const companyQuery = (companyId) => (companyId ? `?company_id=${encodeURIComponent(companyId)}` : "");

/**
 * Trilha de navegação da Diretoria. `items` é `[{ label, to? }]`; o último é a página atual (sem
 * link). `back` (`{ label, to }`) é a volta explícita para a página de origem.
 */
export const DirectorBreadcrumb = ({ items = [], back = null }) => {
  if (items.length === 0) return null;
  return <nav className="director-breadcrumb" aria-label="Trilha de navegação">
    <ol>
      {items.map((item, index) => {
        const last = index === items.length - 1;
        return <li key={`${item.label}-${index}`}>
          {!last && item.to
            ? <Link to={item.to}>{item.label}</Link>
            : <span aria-current={last ? "page" : undefined}>{item.label}</span>}
        </li>;
      })}
    </ol>
    {back && <Link className="director-breadcrumb__back" to={back.to}>{back.label}</Link>}
  </nav>;
};

// Trilha "Diretoria › Informações complementares › <página>" a partir do endereço atual (mapa
// rota → seção). Fora de Informações complementares não mostra nada.
export const complementaryTrail = (pathname, companyId) => {
  const query = companyQuery(companyId);
  const root = { label: "Diretoria", to: `${PRIMARY_SCREENS[0].path}${query}` };
  if (pathname === COMPLEMENTARY_PATH) return { items: [root, { label: COMPLEMENTARY_LABEL }], back: null };
  const match = complementaryPageFor(pathname);
  if (!match) return null;
  return {
    items: [root, { label: COMPLEMENTARY_LABEL, to: `${COMPLEMENTARY_PATH}${query}` }, { label: match.page.label }],
    back: { label: `Voltar a ${COMPLEMENTARY_LABEL}`, to: `${COMPLEMENTARY_PATH}${query}` },
  };
};

const RouteBreadcrumb = () => {
  const { pathname } = useLocation();
  const { selectedCompanyId } = useDirectorContext();
  const trail = complementaryTrail(pathname, selectedCompanyId);
  return trail ? <DirectorBreadcrumb items={trail.items} back={trail.back} /> : null;
};

// Só monta a trilha automática dentro de um roteador (há testes de tela sem roteador).
export const DirectorRouteBreadcrumb = () => {
  const inRouter = typeof useInRouterContext === "function" && useInRouterContext();
  return inRouter ? <RouteBreadcrumb /> : null;
};

export default DirectorBreadcrumb;
